"use client";

import { useState } from "react";

interface ShareButtonProps {
  path?: string;
  title?: string;
  className?: string;
}

export function ShareButton({ path, title, className }: ShareButtonProps) {
  const [copied, setCopied] = useState(false);

  async function handleClick() {
    const url = path ? `${window.location.origin}${path}` : window.location.href;
    if (typeof navigator !== "undefined" && "share" in navigator) {
      try {
        await navigator.share({ url, title });
        return;
      } catch {
        // user cancelled or share unavailable — fall through to clipboard
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // clipboard blocked — ignore silently
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={
        className ??
        "text-muted-foreground text-xs border border-surface-light/30 rounded-md px-3 py-1.5 hover:bg-surface/50 transition cursor-pointer bg-transparent"
      }
    >
      {copied ? "✓ Copied!" : "🔗 Share"}
    </button>
  );
}
